import React from 'react';
import MarketPage from '../../App/Dashboard/Market.tsx'; 


function Trade() {
    return (
        <div>
           <MarketPage />
        </div>
    );
}

export default Trade;
